import Typography from "antd/lib/typography";
import clsx from "clsx";
import { ReactNode } from "react";
import { useId } from "react-aria";
import { Merge } from "type-fest";

import { InformationCircleContained } from "@sol/uikit/core/icons/General/InformationCircleContained";
import { Tooltip } from "@sol/uikit/data-display/Tooltip/Tooltip";
import { Button } from "@sol/uikit/general/Button/Button";

type Props = Merge<
    React.HTMLAttributes<HTMLElement>,
    {
        title?: string | ReactNode;
        tooltip?: string;
        helper?: ReactNode;
        className?: string;
        children: ReactNode;
        "data-cy"?: string;
    }
>;

export const SectionCard = ({ children, title, helper, className, "data-cy": dataCy, tooltip, ...rest }: Props) => {
    const titleId = useId();
    const isTitleString = typeof title === "string";

    return (
        <section
            tabIndex={0}
            className={clsx("focus-classes rounded-ant-lg bg-ant-container p-ant-xl focus:outline-hidden", className)}
            aria-labelledby={titleId}
            {...rest}
            data-cy={clsx("home-card-section", dataCy)}
        >
            {title && (
                <header className="mb-ant-xl flex flex-col" id={titleId}>
                    <div className="flex items-center justify-between gap-ant">
                        <div className="flex items-center gap-ant-xs">
                            {isTitleString ? (
                                <Typography.Title level={1} className="mb-0! text-ant-h1" id={titleId}>
                                    {title}
                                </Typography.Title>
                            ) : (
                                title
                            )}
                            {tooltip ? (
                                <Tooltip title={tooltip} trigger={["hover", "click"]} placement="right">
                                    <Button
                                        color="primary"
                                        variant="text"
                                        icon={
                                            <InformationCircleContained
                                                variant="antd"
                                                className="inline-block text-ant-xl"
                                            />
                                        }
                                    ></Button>
                                </Tooltip>
                            ) : null}
                        </div>
                        <div className="flex items-center gap-ant">{helper}</div>
                    </div>
                </header>
            )}

            {children}
        </section>
    );
};
